import { toggleNav } from '../js/main'
import '../css/reset.css'
import '../css/constants.css'
import '../css/main.css'
import './downloads.css'
toggleNav()
console.log('this is downloads page');